import { render, staticRenderFns } from "./ApiDropdown.vue?vue&type=template&id=48b772ce&scoped=true&lang=pug&"
import script from "./ApiDropdown.vue?vue&type=script&lang=js&"
export * from "./ApiDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ApiDropdown.vue?vue&type=style&index=0&id=48b772ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b772ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAvatar,VDivider,VForm,VSimpleTable})
